import { errorMessageKey } from '@nucleus-commerce/admin-kit/errors';
import { createQueryClient } from '@nucleus-commerce/admin-kit/query';
import { toast } from '@nucleus-commerce/ui/components/sonner';

import { i18n } from './i18n';

export const queryClient = createQueryClient({
  notifyError: (error) => {
    const { keys, requestId } = errorMessageKey(error);
    toast.error(i18n.t(keys.map((k) => `errors:${k}`)), {
      description: requestId ? i18n.t('errors:requestIdShort', { requestId }) : undefined,
    });
  },
  notifySuccess: (key) => {
    toast.success(i18n.t(key));
  },
});
